// Products page Indonesian translations

export default {
  pageTitle: "Produk",
  breadcrumbHome: "Beranda",
  breadcrumbProducts: "Produk",
  title: "Produk",
  description: "Jelajahi berbagai solusi sealing berkualitas tinggi dan komponen presisi yang dirancang untuk aplikasi otomotif, maritim, dirgantara, dan industri umum.",
  searchByCategory: "Cari berdasarkan \nkategori",
  searchByIndustry: "Cari berdasarkan \nIndustri",
  searchByKeyword: "Cari berdasarkan \nkata kunci",
  enterKeywords: "Masukkan kata kunci produk",
  allProducts: "Semua Produk",
  allIndustries: "Semua Industri",
  items: "item",
  showingProductsFor: "Menampilkan produk untuk:",
  category: "Kategori",
  industry: "Industri",
  keyword: "Kata Kunci",
  noProductsFound: "Tidak ada produk yang ditemukan",
  noProductsDescription: "Tidak ada produk yang tersedia untuk filter yang dipilih.",
  inquireNow: "Inkuiri Sekarang",
  viewDetails: "Lihat Detail",
  cardView: "Tampilan Kartu",
  listView: "Tampilan Daftar",
  
  // Categories
  mechanicalSeals: "Mechanical Seal",
  lipSeal: "Lip Seal",
  valves: "Katup",
  floatingSeal: "Floating Seal",
  accumulators: "Akuumulator",
  waterLubricatedSternTubeSeal: "Water Lubricated Stern Tube Seal",
  waterLubricatedSternTubeBearing: "Water Lubricated Stern Tube Bearing",
  serviceEngineer: "Service Engineer",
  
  // Industries
  oilGas: "Minyak, Gas & Industri Umum",
  automobile: "Otomotif & Sepeda Motor",
  constructionAgriculture: "Konstruksi & Pertanian",
  marine: "Maritim",
  semiconductor: "Semikonduktor",
  
  // Product Names
  eh795: "Segel Mekanis untuk Pompa Air EH795/EH790",
  eh795Desc: "Mampu untuk rotasi kecepatan tinggi. Produksi massal dengan jalur perakitan otomatis penuh dan disuplai ke produsen water pump di seluruh dunia. Dengan desain unitized-nya, EH795 mendukung instalasi yang mudah ke aplikasi pelanggan.",
  lipSealAc: "Lip Seal Untuk Kompresor A/C",
  lipSealAcDesc: "Segelan poros berputar yang dirancang khusus untuk kompresor AC mobil. Desain asli Eagle Industry yang menampilkan kompaksi dan keandalan tinggi. Membantu menghilangkan kebocoran CFC yang menyebabkan pemanasan global.",
  reedValve: "Reed Valve",
  reedValveDesc: "Dirancang untuk mesin sepeda motor empat tak untuk kontrol emisi. Secara substansial mengurangi emisi karbon monoksida dan hidrokarbon untuk mengurangi polusi udara.",
  airCutValve: "Air Cut Valve",
  airCutValveDesc: "Dipasang pada mesin sepeda motor empat tak. Dirancang untuk pengaturan emisi gas buang (pasokan udara sekunder).",
  floatingSeal: "Floating Seal",
  floatingSealDesc: "Segelan untuk undercarriage mesin konstruksi. Struktur sederhana yang terdiri dari O-ring dan cincin segel yang terbuat dari besi cor khusus. Segelan optimal untuk undercarriage bulldozer dan ekskavator hidraulik.",
  superiorORing: "SUPERIOR O-Ring",
  superiorORingDesc: "Material O-Ring yang baru dikembangkan dengan resistensi kimia yang lebih baik, generasi outgas rendah, dan resistensi panas ringan untuk industri proses semikonduktor.",
  bladderAccumulator: "Bladder Type Accumulator",
  bladderAccumulatorDesc: "Akuumulator bladder standar ini diproduksi berdasarkan pengalaman bertahun-tahun dan kinerja yang terbukti.",
  evk2rv: "Water Lubricated Stern Tube Seal - EVK",
  evk2rvDesc: "Segel berpelumas air yang kompak dan berkinerja tinggi yang memiliki resistensi getaran dan kinerja penyegelan yang sangat baik.",
  evk2rt: "Water Lubricated Stern Tube Seal - EVK2RT",
  evk2rtDesc: "Segel berpelumas air yang kompak dan berkinerja tinggi yang memiliki resistensi getaran dan kinerja penyegelan yang sangat baik. Jenis segel EVK adalah yang termudah dari segel di pasar untuk instalasi dan operasi. Cincin cadangan mudah diaktifkan tanpa membongkar.",
  mas: "Marine Ace Seal (MAS)",
  masDesc: "Segel stern berpelumas air untuk kapal kecil dengan sistem penggerak langsung. Fitur struktur segel ujung untuk kinerja penyegelan yang sangat baik.",
  rudderSeal: "Rudder Seal (RSC)",
  rudderSealDesc: "Produksi segel kemudi dengan segelan bibir self-lubricating berkinerja tinggi yang dirancang untuk dipasang di atas bantalan kemudi untuk mencegah masuknya air laut ke lambung. Diproduksi dari karet khusus, memberikan masa pakai aus yang lama tanpa perlu penyesuaian berkala, beroperasi dengan lebih sedikit hambatan dan mengurangi aus poros/liner.",
  evr: "Water Lubricated Stern Tube Bearing - EVR",
  evrDesc: "Daya Tahan dan Penyerapan Getaran yang Sangat Baik. Dirancang khusus untuk aplikasi maritim dengan sistem poros berpelumas air.",
  evu: "Water Lubricated Stern Tube Bearing - EVU",
  evuDesc: "Bantalan Poli-Urethane yang dikembangkan untuk sistem stern tube berpelumas air berdasarkan teknologi dan pengalaman bantalan berpelumas air kami yang luas.",
  serviceEngineer: "Service Engineer",
  serviceEngineerDesc: "Layanan teknik profesional untuk sistem sealing kapal Anda. Kami menyediakan service engineer yang sangat terampil dan berpengalaman untuk menangani semua aspek sealing maritim."
};